// extracted by mini-css-extract-plugin
export default {"wrapper":"keycap_wrapper__gDxkv","wrapper_square":"keycap_wrapper_square__gHMzF","wrapper_rectangle":"keycap_wrapper_rectangle__RlAya"};